interface DownloadProps {
    color?: string;
    width?: number;
    height?: number;
}

const Download = ({
    color = 'black',
    width = 24,
    height = 24
}: DownloadProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M12 15.248C11.8927 15.248 11.7933 15.2303 11.702 15.195C11.6107 15.1597 11.5217 15.0983 11.435 15.011L8.815 12.392C8.71767 12.2947 8.667 12.18 8.663 12.048C8.659 11.916 8.70967 11.795 8.815 11.685C8.92567 11.5743 9.04467 11.518 9.172 11.516C9.3 11.514 9.419 11.5683 9.529 11.679L11.5 13.65V5.50001C11.5 5.35801 11.5477 5.23901 11.643 5.14301C11.7383 5.04701 11.8573 4.99934 12 5.00001C12.1427 5.00067 12.2617 5.04834 12.357 5.14301C12.4523 5.23767 12.5 5.35667 12.5 5.50001V13.65L14.471 11.679C14.5683 11.5817 14.684 11.5307 14.818 11.526C14.952 11.5213 15.074 11.5743 15.184 11.685C15.2907 11.795 15.345 11.913 15.347 12.039C15.349 12.165 15.295 12.2827 15.185 12.392L12.565 15.012C12.4783 15.0987 12.3893 15.1597 12.298 15.195C12.2073 15.2303 12.108 15.248 12 15.248ZM6.616 19C6.15533 19 5.771 18.846 5.463 18.538C5.155 18.23 5.00067 17.8453 5 17.384V15.461C5 15.319 5.04767 15.2003 5.143 15.105C5.23833 15.0097 5.35733 14.9617 5.5 14.961C5.64267 14.9603 5.76167 15.0083 5.857 15.105C5.95233 15.2017 6 15.3203 6 15.461V17.384C6 17.538 6.064 17.6793 6.192 17.808C6.32 17.9367 6.461 18.0007 6.615 18H17.385C17.5383 18 17.6793 17.936 17.808 17.808C17.9367 17.68 18.0007 17.5387 18 17.384V15.461C18 15.319 18.0477 15.2003 18.143 15.105C18.2383 15.0097 18.3573 14.9617 18.5 14.961C18.6427 14.9603 18.7617 15.0083 18.857 15.105C18.9523 15.2017 19 15.3203 19 15.461V17.384C19 17.8447 18.846 18.229 18.538 18.537C18.23 18.845 17.8453 18.9993 17.384 19H6.616Z"
            fill={color}
        />
    </svg>
);

export default Download;

